/**
 * The six roles from § 3. Adding a seventh must not grant it access to
 * anything: every RoleGuard uses an explicit allow-list, never a negative test.
 */
export const DASHBOARD_ROLES = [
  'Tollit',
  'Driver',
  'GroundHandler',
  'ReceivingTerminal',
  'LastMileCustomerService',
  'SenderCustomer',
] as const;

export type DashboardRole = (typeof DASHBOARD_ROLES)[number];

/**
 * The response of `GET /api/v1/me`, and the app's only source of truth for who
 * the user is. Deliberately absent: customer numbers, location codes, terminal
 * codes — anything describing the user's data scope. Scope is resolved
 * server-side from the token and is never sent by or returned to the client.
 */
export interface Session {
  displayName: string;
  email: string;
  role: DashboardRole;
  organisationName: string | null;
  /**
   * A coarse capability list for rendering only. Hiding a control the role
   * cannot use is a courtesy; the backend rejects the call regardless, and the
   * app must stay correct if someone edits this array in memory.
   */
  permissions: string[];
}
